import { Box, Text, Tooltip } from '@chakra-ui/react';

export default function MetricCard({ label, value, icon, color = 'gray.700', tooltip }) {
  return (
    <Tooltip label={tooltip} hasArrow placement="top" bg="gray.700" color="white" borderRadius="md">
      <Box
        bg="white"
        borderRadius="xl"
        border="1px solid"
        borderColor="gray.200"
        p={6}
        display="flex"
        alignItems="center"
        gap={4}
        minH="110px"
        cursor={tooltip ? 'help' : 'default'}
        transition="box-shadow 0.2s"
        _hover={{ boxShadow: tooltip ? 'md' : 'none' }}
      >
        {icon && <Box mr={2}>{icon}</Box>}
        <Box>
          <Text fontWeight="medium" color="gray.500" fontSize="sm" mb={1}>{label}</Text>
          <Text fontWeight="bold" color={color} fontSize="2xl">{value}</Text>
        </Box>
      </Box>
    </Tooltip>
  );
} 